import React, { MouseEventHandler } from 'react';

import { Heading2, Text, TextLink } from '@lightspeed/flame/Text';

import { formatCurrency } from '../PurchaseOrder/ShipmentHistory/utils/format';
import { CapitalOffer } from './BusinessSnapshot.types';
import CostVsSalesChart from './CostVsSalesChart';

type Props = {
  offer: CapitalOffer;
  onLearnMore: MouseEventHandler;
  data: any;
  isLoading: boolean;
  isError: boolean;
};

export function CostVsSales({ offer, onLearnMore, data, isLoading, isError }: Props) {
  return (
    <>
      <Heading2>
        {data && data?.data?.chartData?.is_from_vertical
          ? 'Businesses like yours often had inventory costs outpacing sales this time last year.'
          : 'Struggling to fund large inventory purchases during slow sales periods?'}
      </Heading2>
      <CostVsSalesChart
        data={data && data?.data?.chartData?.sale_to_cost_by_months}
        isLoading={isLoading}
        isError={isError}
      />
      <Text fontSize="18px">
        Secure up to <span>{formatCurrency(offer.offerAmount, offer.currency, true)}</span> with{' '}
        <TextLink href="#" onClick={onLearnMore}>
          Lightspeed Capital
        </TextLink>{' '}
        to get ahead of your invoices when your inventory costs outpace your sales.
      </Text>
    </>
  );
}
